import { memoizeWith, identity } from 'ramda';
import shareLast from './share-last';

export default function cached$(create$) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;

  return memoizeWith(key, withReplay$);
  function withReplay$(key) {
    return create$(key).pipe(shareLast);
  }
}